// team.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const useTeamStore = defineStore('team', {
    state: () => ({
        allTeam: JSON.parse(localStorage.getItem('allTeam')) || [],
        teamList: [],
    }),
    actions: {
        async getAllTeam(filter) {
            try {
                const response = await axios.get('teams', { params: filter })

                if (response.status === 200) {
                    this.allTeam = response.data.data


                    localStorage.setItem(
                        'allTeam',
                        JSON.stringify(response.data.data)
                    )
                }

                return response
            } catch (error) {
                console.error('error:', error)
                loadTeamFromLocal()
                throw error
            }
        },

        loadTeamFromLocal() {
            const data = localStorage.getItem('allTeam')
            if (data) {
                this.allTeam = JSON.parse(data)
            }
        },

        clearTeam() {
            localStorage.removeItem('allTeam')
            this.allTeam = []
        },
        async getTeam(filter) {
            try {
                const response = await axios.get('/teams', { params: filter })
                if (response.status === 200) {
                    this.teamList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getTeamById(id) {
            try {
                const response = await axios.get(`/team/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createTeam(body) {
            try {
                const response = await axios.post('/team', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateTeam(body) {
            try {
                const response = await axios.post(`/team/${body.id}`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteTeam(id) {
            try {
                const response = await axios.delete(`/team/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async joinTeam(body) {
            try {
                const response = await axios.post('/member/join', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async transferTeam(body) {
            try {
                const response = await axios.post('/member/transfer', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async leaveTeam(body) {
            try {
                const response = await axios.post('/member/leave', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})